
export function csvToJsonAnAbreise(csv: string) {
    const results: any = { uebernachtungen: {}, entfernungen: {} };
    const rows = csv.split('\n');

    if (!rows || rows.length === 0) {
        results.rows = 0;
        return results;
    }

    let row_count = 0;
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const fields = row.split(';');

        if (fields.length < 12) {
            continue;
        }

        const indices = getIndices(fields[0]);

        if (!indices.ver1) {
            // Ab Version 2 gibt es Version-Info am gangz Anfang.
            fields.shift();
        }
        // console.log(fields, indices);

        // const factor = +fields[11] || 1;
        const factor = +fields[indices.factor] || 1;
        // console.log(factor);

        row_count += 0.5 * factor;

        const personenzahl = +fields[indices.personenzahl] || 1;
        const uebernachtungen = +fields[indices.uebernachtung] || 0;

        // for (let c = 3 ; c <= 9 ; c++) {
        for (let c = 3; c <= indices.fieldNum; c++) {
            const value = +fields[c];

            // const key = getTransportmittelForCol(c, value);
            const key = indices.ver1 ? getTransportmittelForCol(c, value) :
                indices.ver2 ? getTransportmittelForCol_v2(c, value) :
                    indices.ver3 || indices.ver4 ? getTransportmittelForCol_v3_v4(c, value) :
                        indices.ver5 ? getTransportmittelForCol_v5(c, value) :
                            indices.ver6 ? getTransportmittelForCol_v6(c, value) : null;
            // console.log(c, key);

            if (value && value > 0) {
                if (!results.entfernungen[key]) {
                    results.entfernungen[key] = {};
                    results.entfernungen[key].km = 0;
                    results.entfernungen[key].cnt = 0;
                }
                // results.entfernungen[key].cnt += factor / 2;
                // results.entfernungen[key].km += value * factor;
                results.entfernungen[key].cnt += personenzahl;
                results.entfernungen[key].km += value * factor * personenzahl;
            }
        }

        // WKETOOL-125: "Besucherinnen Befragung"
        if (!results.personenzahl) {
            results.personenzahl = 0;
        }
        results.personenzahl += personenzahl * factor / 2;

        if (uebernachtungen > 0) {
            // const ue_typ_raw = fields[13];
            const ue_typ_raw = fields[indices.uebernachtungTyp];
            // console.log(ue_typ_raw);

            const ue_typ_real = getUebernachtungsKey(ue_typ_raw);
            if (ue_typ_real) {
                if (!results.uebernachtungen[ue_typ_real]) {
                    results.uebernachtungen[ue_typ_real] = {};
                    results.uebernachtungen[ue_typ_real].anzahl = 0;
                    results.uebernachtungen[ue_typ_real].cnt = 0;
                }
                results.uebernachtungen[ue_typ_real].cnt++;
                results.uebernachtungen[ue_typ_real].anzahl += uebernachtungen * personenzahl;
            }
        }
    }

    // console.log(rows, results);

    results.rows = row_count;
    return results;
}

function getUebernachtungsKey(value: string) {
    switch (value) {
        case 'h0': return 'hotel_0';
        case 'h3': return 'hotel_3';
        case 'h4': return 'hotel_4';
        case 'h5': return 'hotel_5';
        case 'fw': return 'ferien';
        case 'ca': return 'camping';
        case 'hp': return 'hostel';
        case 'pr': return 'privat';
    }
    return null;
}

function getTransportmittelForCol(col: number, value: number) {
    switch (col) {
        case 3: return 'fuss';
        case 4: return 'oepnv_tram';
        case 5: return 'oepnv_zug';
        case 6: return 'oepnv_bus';
        case 7: return 'auto_elektro';
        case 8: return 'auto';
        case 9: {
            if (value <= 750) {
                return 'flugzeug_national';
            }
            return 'flugzeug_international';
        }

    }
    return null;
}

function getTransportmittelForCol_v2(col: number, value: number) {
    switch (col) {
        case 3: return 'fuss';
        case 4: return 'oepnv_tram';
        case 5: return 'oepnv_zug';
        case 6: return 'oepnv_bus';
        case 7: return 'auto_elektro';
        case 8: return 'auto';
        case 9: return 'krad';
        case 10: {
            if (value <= 750) {
                return 'flugzeug_national';
            }
            return 'flugzeug_international';
        }

    }
    return null;
}

function getTransportmittelForCol_v3_v4(col: number, value: number) {
    switch (col) {
        case 3: return 'fuss';
        case 4: return 'oepnv_tram';
        case 5: return 'oepnv_zug';
        case 6: return 'oepnv_bus';
        case 7: return 'reisebus';
        case 8: return 'auto_elektro';
        case 9: return 'auto';
        case 10: return 'krad';
        case 11: {
            if (value <= 750) {
                return 'flugzeug_national';
            }
            return 'flugzeug_international';
        }

    }
    return null;
}

function getTransportmittelForCol_v5(col: number, value: number) {
    switch (col) {
        case 3: return 'fuss';
        case 4: return 'oepnv_tram';
        case 5: return 'oepnv_zug';
        case 6: return 'oepnv_zug_fern';
        case 7: return 'oepnv_bus';
        case 8: return 'reisebus';
        case 9: return 'auto_elektro';
        case 10: return 'auto';
        case 11: return 'krad';
        case 12: {
            if (value <= 750) {
                return 'flugzeug_national';
            }
            return 'flugzeug_international';
        }

    }
    return null;
}

function getTransportmittelForCol_v6(col: number, value: number) {
    switch (col) {
        case 3: return 'fuss';
        case 4: return 'e_bike';
        case 5: return 'oepnv_tram';
        case 6: return 'oepnv_zug';
        case 7: return 'oepnv_zug_fern';
        case 8: return 'oepnv_bus';
        case 9: return 'reisebus';
        case 10: return 'auto_elektro';
        case 11: return 'auto';
        case 12: return 'krad';
        case 13: {
            if (value <= 750) {
                return 'flugzeug_national';
            }
            return 'flugzeug_international';
        }

    }
    return null;
}

function getIndices(version: string = null): any {
    // Indices: Datum;Sprache;Primär;FussRad;Bahn;Tram;Bus;E-Auto;Auto;Flugzeug;Übernachtung;Faktor;Art;Unterkunft;
    const indices = {
        ver1: true,
        fieldNum: 9,
        uebernachtung: 10,
        factor: 11,
        uebernachtungTyp: 13
    }
    // Ab Version 2 gibt es Version und Motorrad.
    // Indices: Version;Datum;Sprache;Primär;FussRad;Bahn;Tram;Bus;E-Auto;Auto;Motorrad;Flugzeug;Übernachtung;Faktor;Art;Unterkunft;
    const indices_v2 = {
        ver2: true,
        fieldNum: 10,
        uebernachtung: 11,
        factor: 12,
        uebernachtungTyp: 14
    }
    // Ab Version 3 gibt es Fern-/Reisebus.
    // Indices: Version;Datum;Sprache;Primär;FussRad;Bahn;Tram;Bus;Reisebus;E-Auto;Auto;Motorrad;Flugzeug;Übernachtung;Faktor;Art;Unterkunft;
    const indices_v3 = {
        ver3: true,
        fieldNum: 11,
        uebernachtung: 12,
        factor: 13,
        uebernachtungTyp: 15
    }
    // Ab Version 4 gibt es die Personenzahl.
    // Indices: Version;Datum;Sprache;Primär;FussRad;Bahn;Tram;Bus;Reisebus;E-Auto;Auto;Motorrad;Flugzeug;Übernachtung;Personenzahl;Faktor;Art;Unterkunft;
    const indices_v4 = {
        ver4: true,
        fieldNum: 11,
        uebernachtung: 12,
        personenzahl: 13,
        factor: 14,
        uebernachtungTyp: 16
    }
    // Ab Version 5 gibt es Fernverkehr (ICE, IC, EC).
    // Indices: Version;Datum;Sprache;Primär;FussRad;Bahn(Nahverkehr);Bahn(Fernverkehr);Tram;Bus;Reisebus;E-Auto;Auto;Motorrad;Flugzeug;Übernachtung;Personenzahl;Faktor;Art;Unterkunft;
    const indices_v5 = {
        ver5: true,
        fieldNum: 12,
        uebernachtung: 13,
        personenzahl: 14,
        factor: 15,
        uebernachtungTyp: 17
    }
    // Ab Version 6 gibt es E-Bike.
    // Indices: Version;Datum;Sprache;Primär;FussRad;E-Bike;Bahn(Nahverkehr);Bahn(Fernverkehr);Tram;Bus;Reisebus;E-Auto;Auto;Motorrad;Flugzeug;Übernachtung;Personenzahl;Faktor;Art;Unterkunft;
    const indices_v6 = {
        ver6: true,
        fieldNum: 13,
        uebernachtung: 14,
        personenzahl: 15,
        factor: 16,
        uebernachtungTyp: 18
    }

    if (version === 'version-2') {
        return indices_v2;
    }
    if (version === 'version-3') {
        return indices_v3;
    }
    if (version === 'version-4') {
        return indices_v4;
    }
    if (version === 'version-5') {
        return indices_v5;
    }
    if (version === 'version-6') {
        return indices_v6;
    }
    return indices;
}